import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../content/i18n';
import './TopBar.css';

const TopBar = () => {
  const { lang, setLang, t } = useI18n();

  return (
    <div className="topbar" role="banner">
      <div className="topbar-inner container">
        <Link to="/" className="topbar-brand link" aria-label={t.common.brand}>
          <span className="mimic-brand">{t.common.brand}</span>
        </Link>

        <div className="topbar-spacer" />

        <nav className="topbar-nav" aria-label="Top navigation">
          <Link to="/terms" className="topbar-navlink link" target="_blank" rel="noopener noreferrer">
            {t.footer.links.terms}
          </Link>
          <Link to="/privacy" className="topbar-navlink link" target="_blank" rel="noopener noreferrer">
            {t.footer.links.privacy}
          </Link>
        </nav>

        <div className="topbar-actions">
          <div className="lang-switch" role="group" aria-label={t.topBar.ariaLangSwitch}>
            <button
              type="button"
              className={`lang-btn ${lang === 'ko' ? 'active' : ''}`}
              onClick={() => setLang('ko')}
            >
              {t.topBar.langKo}
            </button>
            <button
              type="button"
              className={`lang-btn ${lang === 'en' ? 'active' : ''}`}
              onClick={() => setLang('en')}
            >
              {t.topBar.langEn}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;


